import { EApiError } from './EApiError'

/** Erreur renvoyée lorsque l’API retourne 422 avec une liste d’erreurs par champ (validation Vine). */
export class ApiValidationError extends EApiError {
  /** Erreurs par nom de champ (un ou plusieurs messages par champ). */
  readonly fieldErrors: Record<string, string[]>

  constructor(message: string, fieldErrors: Record<string, string[]>) {
    super(message)
    this.name = 'ApiValidationError'
    this.fieldErrors = fieldErrors
  }
}
